// eslint-disable-next-line import/prefer-default-export
export const currentModalSelector = ({ core: { currentModal } }) => currentModal;
